import React, { useEffect, useRef, useState } from "react";
import { TextField, Button, MenuItem, Card, Typography, IconButton, Switch } from "@mui/material";
import { categoryApi } from "store/api";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CategoryClip from "./CategoryClip";
import Tooltip from "@mui/material/Tooltip";
import { useLocation } from "react-router";
import { productDetailApi } from "store/api";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import { productUpdateDimentionsDetailsApi } from "store/api";
import { productUpdateBasicDetailsApi } from "store/api";
import TooltipShow from "components/Utilities/TooltipShow";
import DeleteIcon from "@mui/icons-material/Delete";
import UpgradeRoundedIcon from "@mui/icons-material/UpgradeRounded";
import { updateProductDescriptionApi } from "store/api";
import { updateProductInventryApi } from "store/api";
import { updateProductCharacteristicApi } from "store/api";
import { updateProductColorApi } from "store/api";
import Success from "components/Success";
import { updateProductWarrantyApi } from "store/api";
import { updateProductVideoApi } from "store/api";
import BrandClip from "../BrandClip";
import { getAllBrandApi } from "store/api";
import { subCategoryApi } from "store/api";
import { DeleteRounded } from "@mui/icons-material";

const ProductEditForm = () => {
  const location = useLocation();
  const productParams = location.state;
  const [msg, setMsg] = useState("");
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [categories, setCategories] = useState([]);
  const [checkCallAPI, setCheckCallAPI] = useState(false);

  const [seeDescription, setSeeDescription] = useState(false);
  const [indexDimention, setIndexDimention] = useState("");
  const [addDescriptionShow, setAddDescriptionShow] = useState(false);

  const [seeCharacteristic, setSeeCharacteristic] = useState(false);
  const [indexCharacteristic, setIndexCharacteristic] = useState("");
  const [addCharacteristicShow, setAddCharacteristicShow] = useState(false);

  const [seeWarranty, setSeeWarranty] = useState(false);
  const [indexWarranty, setIndexWarranty] = useState("");
  const [addWarrantyShow, setAddWarrantyShow] = useState(false);

  const [seeColor, setSeeColor] = useState(false);
  const [indexColor, setIndexColor] = useState("");
  const [addColorShow, setAddColorShow] = useState(false);

  const [seeVideo, setSeeVideo] = useState(false);
  const [indexVideo, setIndexVideo] = useState("");
  const [addVideoShow, setAddVideoShow] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCategoryClone, setSelectedCategoryClone] = useState([]);
  const [basicDetail, setBasicDetail] = useState({
    name: "",
    slug: "",
    description: "",
    price: 0,
    discountPrice: 0,
    rating: "",
    brandId: "",
    trending: true,
    isActive: true,
    subCategoryIds: [],
    productAttributes: [],
  });
  const [filters, setFilters] = useState([]);
  const [dimensions, setDimentions] = useState({
    weight: "",
    length: "",
    width: "",
    height: "",
  });
  const getAllCategory = async () => {
    const response = await categoryApi();
    if (response?.success) {
      setCategories(response?.data);
    }
  };

  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [checkedTrending, setCheckedTrending] = useState(false);
  const [checkedIsActive, setCheckedIsActive] = useState(false);

  const handleChangeTrending = event => {
    setCheckedTrending(event.target.checked);
    setBasicDetail(prev => ({
      ...prev,
      trending: event.target.checked,
    }));
  };
  const handleChangeIsActive = event => {
    setCheckedIsActive(event.target.checked);
    setBasicDetail(prev => ({
      ...prev,
      isActive: event.target.checked,
    }));
  };

  const handleChangeBasicDetail = e => {
    const { name, value } = e.target;
    setBasicDetail({ ...basicDetail, [name]: value });
  };
  // Handle input change
  const handleChangeCharacteristic = (index, event) => {
    const { name, value } = event.target;
    setBasicDetail(prev => {
      const updatedAttributes = [...prev.productAttributes];
      updatedAttributes[index] = {
        ...updatedAttributes[index],
        [name]: value,
      };

      return {
        ...prev,
        productAttributes: updatedAttributes,
      };
    });
  };

  // Add new Characteristic
  const addCharacteristic = () => {
    setBasicDetail(prev => ({
      ...prev,
      productAttributes: [
        ...basicDetail.productAttributes,
        { id: Date.now(), key: "", value: "", isActive: true, operation: "add" },
      ],
    }));
  };

  const removeCharacteristic = async productAttributeId => {
    let apiData = {
      productId: basicDetail?.productId,
      subCategoryIds: selectedSubCategories.map(({ subCategoryId, isActive }) => ({
        categoryId: subCategoryId,
        status: isActive,
      })),
      productAttributes: [
        {
          productAttributeId: productAttributeId,
          operation: "delete",
        },
      ],
    };
    const response = await productUpdateBasicDetailsApi(apiData);
    if (response?.success) {
      setMsg("Product Delete Successfully");
      setSuccess(true);
      getProductDetails();
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    if (response?.response) {
      setSuccess(false);
      setMsg(response?.response?.data?.message);
    }
    setOpen(true);
  };

  const handleChangeDescription = event => {
    const { value } = event.target;
    setBasicDetail(prev => ({
      ...prev,
      description: value,
    }));
  };

  const getProductDetails = async () => {
    const response = await productDetailApi(productParams);
    if (response?.success) {
      setBasicDetail(response.data.productDetails);
      // setBasicDetail(prev => ({
      //   ...prev,
      //   productAttributes: response.data.productDetails?.attributes,
      // }));
      setBasicDetail(prev => ({
        ...prev,
        productAttributes:
          response.data.productDetails?.attributes?.map(attr => ({
            ...attr,
            operation: "edit",
          })) || [],
      }));
      setSelectedBrand([response.data.productDetails?.brand])
      setFilters(response.data.filters);
    }
  };

  const handleBasicDetail = async e => {
    e?.preventDefault();
    const categoryData = selectedSubCategories.map(({ subCategoryId, isActive }) => ({
      categoryId: subCategoryId,
      status: isActive,
    }));
    let apiData = {};
    apiData = basicDetail;
    apiData.subCategoryIds = categoryData;
    apiData.productId = productParams?.productId;
    apiData.image = false;
    apiData.rating = String(basicDetail.rating);
    apiData.brandId = selectedBrand[0]?.brandId
    const response = await productUpdateBasicDetailsApi(apiData);
    if (response?.success) {
      setMsg("Product Update Successfully");
      setSuccess(true);
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    if (response?.response) {
      setSuccess(false);
      setMsg(response?.response?.data?.message);
    }
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const [selectedSubCategories, setSelectedSubCategories] = useState([]);

  const fetchSubCategories = async categoryId => {
    const response = await subCategoryApi({ categoryId: categoryId });
    if (response?.success) {
      // setSelectedSubCategories(response?.data);
      return response?.data;
    }
  };

  const getAllBrand = async () => {
    const response = await getAllBrandApi();
    if (response?.success) {
      setBrands(response?.data);
    }
  };

  useEffect(() => {
    if (productParams?.productId) getProductDetails();
  }, [productParams?.productId]);

  useEffect(() => {
    getAllBrand();

    getAllCategory();
  }, []);

  return (
    <form onSubmit={handleBasicDetail}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", paddingBottom: "10px" }}>
        <Card style={{ flex: 1, padding: "20px", minWidth: "100%" }}>
          {/* <DriveFileRenameOutlineRoundedIcon style={{position: 'absolute', right: '20px', top: '20px', fill: '#344767', cursor: 'pointer' }} /> */}
          <Typography variant='h6'>Product Basic Details</Typography>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Product Name'
              name='name'
              variant='outlined'
              margin='normal'
              value={basicDetail?.name}
              onChange={handleChangeBasicDetail}
            />
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Product Slug'
              name='slug'
              variant='outlined'
              margin='normal'
              value={basicDetail?.slug}
              style={{ width: "100%" }}
              onChange={handleChangeBasicDetail}
            />
            {/* <Typography component='legend'>Controlled</Typography>
            <Rating
              name='simple-controlled'
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            /> */}
            <TextField
              required
              type='number'
              select
              inputProps={{ min: 1, max: 5 }}
              fullWidth
              label='Product Rating'
              name='rating'
              variant='outlined'
              margin='normal'
              style={{ width: "30%" }}
              value={basicDetail.rating}
              onChange={handleChangeBasicDetail}
              className='rating-box'
            >
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={1.1}>1.1</MenuItem>
              <MenuItem value={1.2}>1.2</MenuItem>
              <MenuItem value={1.3}>1.3</MenuItem>
              <MenuItem value={1.4}>1.4</MenuItem>
              <MenuItem value={1.5}>1.5</MenuItem>
              <MenuItem value={1.6}>1.6</MenuItem>
              <MenuItem value={1.7}>1.7</MenuItem>
              <MenuItem value={1.8}>1.8</MenuItem>
              <MenuItem value={1.9}>1.9</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={2.1}>2.1</MenuItem>
              <MenuItem value={2.2}>2.2</MenuItem>
              <MenuItem value={2.3}>2.3</MenuItem>
              <MenuItem value={2.4}>2.4</MenuItem>
              <MenuItem value={2.5}>2.5</MenuItem>
              <MenuItem value={2.6}>2.6</MenuItem>
              <MenuItem value={2.7}>2.7</MenuItem>
              <MenuItem value={2.8}>2.8</MenuItem>
              <MenuItem value={2.9}>2.9</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={3.1}>3.1</MenuItem>
              <MenuItem value={3.2}>3.2</MenuItem>
              <MenuItem value={3.3}>3.3</MenuItem>
              <MenuItem value={3.4}>3.4</MenuItem>
              <MenuItem value={3.5}>3.5</MenuItem>
              <MenuItem value={3.6}>3.6</MenuItem>
              <MenuItem value={3.7}>3.7</MenuItem>
              <MenuItem value={3.8}>3.8</MenuItem>
              <MenuItem value={3.9}>3.9</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={4.1}>4.1</MenuItem>
              <MenuItem value={4.2}>4.2</MenuItem>
              <MenuItem value={4.3}>4.3</MenuItem>
              <MenuItem value={4.4}>4.4</MenuItem>
              <MenuItem value={4.5}>4.5</MenuItem>
              <MenuItem value={4.6}>4.6</MenuItem>
              <MenuItem value={4.7}>4.7</MenuItem>
              <MenuItem value={4.8}>4.8</MenuItem>
              <MenuItem value={4.9}>4.9</MenuItem>
              <MenuItem value={5}>5</MenuItem>
            </TextField>
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            <TextField
              required
              type='number'
              inputProps={{ min: 1 }}
              fullWidth
              label='Price'
              name='price'
              variant='outlined'
              margin='normal'
              style={{ width: "50%" }}
              value={basicDetail?.price}
              onChange={handleChangeBasicDetail}
            />
            <TextField
              required
              type='number'
              fullWidth
              inputProps={{ min: 1 }}
              label='Product Discount Price'
              name='discountPrice'
              variant='outlined'
              margin='normal'
              style={{ width: "47.5%" }}
              value={basicDetail?.discountPrice}
              onChange={handleChangeBasicDetail}
            />
            {/* <CategoryClip
              categories={categories}
              selectedCategories={selectedCategory}
              setSelectedCategoryClone={setSelectedCategoryClone}
              setSelectedCategories={setSelectedCategory}
            /> */}
            <BrandClip
              brands={brands}
              brandId={basicDetail?.brandId}
              setSelectedBrand={setSelectedBrand}
              selectedBrand={selectedBrand}
            />
            <CategoryClip
              categories={categories}
              setSelectedCategories={setSelectedCategory}
              fetchSubCategories={fetchSubCategories}
              selectedCategories={selectedCategory}
              selectedSubCategories={selectedSubCategories}
              setSelectedSubCategories={setSelectedSubCategories}
            />
          </div>
        </Card>

        <Card style={{ flex: 1, padding: "20px", minWidth: "50%" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Description
          </Typography>
          <div style={{ display: "flex", gap: "10px", marginBottom: "0px", alignItems: "center" }}>
            <TextField
              required
              type='text'
              fullWidth
              label='Description'
              name='descriptionEn'
              variant='outlined'
              margin='normal'
              multiline
              maxRows={4}
              value={basicDetail.description}
              onChange={e => handleChangeDescription(e)}
            />
          </div>
        </Card>
        <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Attributes
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "10px",
                gap: "2px",
                border: "1px solid",
                borderRadius: "4px",
                padding: "4px 12px 4px 8px",
                fontWeight: "500",
                cursor: "pointer",
              }}
              onClick={addCharacteristic}
            >
              <AddRoundedIcon style={{ fontSize: "36px" }} /> Add
            </span>
          </Typography>
          {basicDetail?.productAttributes.length == 0 && <div style={{fontSize: '14px', color: 'gray', padding: '10px'}}>No Attribute Found</div>}
          {basicDetail?.productAttributes?.map(
            (characteristic, index) =>
              characteristic?.isActive && (
                <div
                  key={characteristic.id}
                  style={{
                    display: "flex",
                    gap: "10px",
                    marginBottom: "0px",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    required
                    type='text'
                    fullWidth
                    label='Attribute Key'
                    name='key'
                    variant='outlined'
                    margin='normal'
                    multiline
                    maxRows={4}
                    value={characteristic.key}
                    style={{ width: "50%" }}
                    onChange={e => handleChangeCharacteristic(index, e)}
                  />
                  <TextField
                    required
                    type='text'
                    fullWidth
                    label='Attribute Value'
                    name='value'
                    variant='outlined'
                    margin='normal'
                    multiline
                    style={{ width: "30%" }}
                    maxRows={4}
                    value={characteristic.value}
                    onChange={e => handleChangeCharacteristic(index, e)}
                  />
                  <TextField
                    required
                    type='number'
                    fullWidth
                    label='Order'
                    name='order'
                    variant='outlined'
                    margin='normal'
                    multiline
                    maxRows={4}
                    style={{ width: "20%" }}
                    value={characteristic.order}
                    onChange={e => handleChangeCharacteristic(index, e)}
                  />

                  {indexCharacteristic == index && (
                    <Tooltip
                      title={"Delete"}
                      onClick={() => {
                        removeCharacteristic(characteristic.productAttributeId);
                        setAddCharacteristicShow(false);
                      }}
                    >
                      <IconButton style={{ fontSize: "20px" }}>
                        <DeleteRounded style={{ fill: "#f35252" }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  {/* {addCharacteristicShow && (
                    <div style={{ display: "flex", paddingTop: "8px" }}>
                      {indexCharacteristic == index && (
                        <TooltipShow
                          onSubmit={handleCharacteristic}
                          data={characteristic}
                          operation='add'
                          icon={<AddRoundedIcon />}
                          title={"Add"}
                        />
                      )}
                      {indexCharacteristic == index && (
                        <Tooltip
                          title={"Close"}
                          onClick={() => {
                            removeCharacteristic(characteristic.id);
                            setAddCharacteristicShow(false);
                          }}
                        >
                          <IconButton style={{ fontSize: "20px" }}>
                            <CloseRoundedIcon style={{ fill: "#f35252" }} />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  )} */}
                </div>
              )
          )}
        </Card>
        <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Trending
          </Typography>
          <Switch
            name='isTrending'
            checked={checkedTrending}
            onChange={handleChangeTrending}
            inputProps={{ "aria-label": "controlled" }}
          />
        </Card>
        <Card style={{ flex: 1, padding: "20px", minWidth: "300px" }}>
          <Typography
            variant='h6'
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            Product Active
          </Typography>
          <Switch
            name='isActive'
            checked={checkedIsActive}
            onChange={handleChangeIsActive}
            inputProps={{ "aria-label": "controlled" }}
          />
        </Card>

        {/* <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
        <button
          type='submit'
          style={{
            border: "1px solid #344767",
            background: "none",
            borderRadius: "4px",
            padding: "10px 10px",
            cursor: "pointer",
            color: "#344767",
            fontSize: "12px",
            fontWeight: "500",
            background: "white",
          }}
        >
          Update Product
        </button>
      </div> */}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            paddingTop: "20px",
            width: "100%",
          }}
        >
          <Button variant='contained' color='success' type='submit'>
            Update Product
          </Button>
        </div>

        <Success open={open} success={success} msg={msg} handleClose={handleClose} />
      </div>
    </form>
  );
};

export default ProductEditForm;

// </form>
